"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/** This component is meant to be used to wrap any content so it can be portaled somewhere else.
 * It also requires that you add a container component with the same id that you provide here as a prop
 * so the content can be rendered inside it
 * Alternatively - you can pass the append `true` prop and a container with the specified ID will be appended at the end of the body, and content portaled inside it
 */
var PortalContent = /*#__PURE__*/function (_React$Component) {
  _inherits(PortalContent, _React$Component);
  var _super = _createSuper(PortalContent);
  function PortalContent(props) {
    var _this;
    _classCallCheck(this, PortalContent);
    _this = _super.call(this, props);
    _this.container = null;
    _this.el = document.createElement("div");
    _this.domCheckerInterval = 0;
    _this.getPortalContainer = _this.getPortalContainer.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PortalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.append) {
        this.domCheckerInterval = setInterval(this.getPortalContainer, 500);
      } else {
        this.el.setAttribute("id", this.props.containerId);
        document.body.appendChild(this.el);
      }
    }
  }, {
    key: "getPortalContainer",
    value: function getPortalContainer() {
      this.container = document.getElementById(this.props.containerId);
      if (this.container !== null) {
        this.container.appendChild(this.el);
        clearInterval(this.domCheckerInterval);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.container) {
        this.container.removeChild(this.el);
      } else if (this.props.append) {
        document.body.removeChild(this.el);
      }
      clearInterval(this.domCheckerInterval);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_reactDom["default"].createPortal(this.props.children, this.el);
    }
  }]);
  return PortalContent;
}(_react["default"].Component);
_defineProperty(PortalContent, "propTypes", {
  /** Id for the portal target container, where content is to be portaled in. It **must exist** for the portal to work.
   *
   * If it doesn't exist then you must use the `append` prop */
  containerId: _propTypes["default"].string.isRequired,
  /** Content to be portaled in the other place  */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /** Append a container with specified `containerID` the end of the body, and portal content inside it */
  append: _propTypes["default"].bool
});
var _default = PortalContent;
exports["default"] = _default;